import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthProvider';
import type { RouteDef } from '../routes';
import { ActionCards } from './ActionCards';

const HOME_COPY: Record<string, string> = {
  morador: 'Sua fatura aparece aqui assim que o síndico fechar o mês.',
  proprietario: 'Saúde do condomínio e balancetes publicados aparecem aqui.',
  sindico: 'Checklist do mês: previsão → gás → faturas → extrato → balancete.',
  contabil: 'Exportações (CSV/PDF) do mês para a contabilidade aparecem aqui.',
};

/**
 * Início do tenant; `cards` já vêm filtrados pelo papel (routes.tsx). `topo` é o bloco
 * do papel acima dos atalhos (checklist do fechamento do síndico).
 */
export function Home({ cards, topo }: { cards: readonly RouteDef[]; topo?: ReactNode }) {
  const { user } = useAuth();
  const copy = user ? (HOME_COPY[user.papel] ?? '') : '';
  return (
    <div>
      <p
        className="muted"
        style={{
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          fontSize: 'var(--step--1)',
          fontWeight: 600,
        }}
      >
        Bem-vindo(a)
      </p>
      <h1>Seu condomínio, sem complicação</h1>
      {copy ? <p className="muted">{copy}</p> : null}
      {topo ? <div style={{ margin: 'var(--space-4) 0' }}>{topo}</div> : null}
      <ActionCards routes={cards} />
    </div>
  );
}
